import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer" className="py-20 md:py-32 px-6 bg-cream" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="bg-card rounded-3xl p-8 md:p-16 shadow-warm-lg border-2 border-gold/30 text-center relative overflow-hidden" data-id="element-101">
            {/* Decorative corner accents */}
            <div className="absolute top-0 left-0 w-24 h-24 bg-gradient-to-br from-sage/10 to-transparent rounded-br-full" data-id="element-102"></div>
            <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-tl from-terracotta/10 to-transparent rounded-tl-full" data-id="element-103"></div>

            <div className="relative z-10" data-id="element-104">
              <h2 className="font-serif text-2xl md:text-3xl text-charcoal mb-4" data-id="element-105">
                Obtenga el Kit Completo
              </h2>
              <h3 className="font-serif text-3xl md:text-4xl text-sage font-bold mb-10" data-id="element-106">
                "Legado en Vida: El Kit de No Me Olvides"
              </h3>

              <div className="mb-8" data-id="element-107">
                <span className="text-lg text-muted block mb-2" data-id="element-108">
                  Por un pago único de solo
                </span>
                <span className="text-6xl md:text-7xl font-serif text-charcoal font-bold block mb-4" data-id="element-109">
                  $6.99{' '}
                  <span className="text-2xl text-muted font-sans font-normal" data-id="element-110">
                    USD
                  </span>
                </span>
                <p className="text-terracotta font-medium text-lg" data-id="element-111">
                  Es menos de lo que cuesta una cena, pero el valor de la paz
                  mental para su familia no tiene precio.
                </p>
              </div>

              <div className="flex flex-col items-center gap-6 mt-12" data-id="element-112">
                <Button href="https://www.hoypleno.com/cart/44176501375062:1" className="w-full md:w-auto text-lg md:text-xl px-10 py-5" data-id="element-113">
                  Descarga Legado en Vida
                </Button>

                <div className="flex items-center gap-2 text-muted text-sm md:text-base" data-id="element-114">
                  <ShieldCheckIcon className="w-5 h-5 text-sage" data-id="element-115" />
                  <span data-id="element-116">
                    Compra 100% segura. Descarga inmediata tras el pago.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}